import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { UFconditional } from 'pages/Contracts/utils/disableUfFields'
import { FormContractKeys } from './types'

interface Schema {
    id: FormContractKeys
}

interface FormContractInterface {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}

const optionsTypeRestrictions = {
    BA: 'typeBA',
    MS: 'typeMS',
    MT: 'typeMS',
    default: 'type'
}

export const FormContractValue = (
    contractRef: string
): FormContractInterface[] => {
    const data = [
        {
            input: {
                id: 'dataContrato',
                label: 'Data Contrato',
                placeholder: 'dd/mm/aaaa',
                type: 'date'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            input: {
                id: 'numeroContrato',
                label: 'Nº do contrato',
                inputMode: 'numeric'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            input: {
                id: 'numeroRegistroContrato',
                label: 'Nº registro do contrato',
                inputMode: 'numeric',
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            select: {
                id: 'tipoRestricao',
                label: 'Tipo de gravame',
                optionsType:
                    optionsTypeRestrictions[contractRef as 'BA' | 'MS'] ||
                    optionsTypeRestrictions.default
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            input: {
                id: 'quantidadeMeses',
                label: 'Quantidade de meses',
                inputMode: 'numeric',
                maxLength: 3
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            input: {
                id: 'numAditivoContratoOrigem',
                label: 'Nº de aditivo',
                inputMode: 'numeric',
                maxLength: 20,
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            input: {
                id: 'numAditivoContrato',
                label: 'Nº registro de aditivo',
                inputMode: 'numeric',
                maxLength: 14,
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            select: {
                id: 'ufContrato',
                label: 'UF do contrato',
                optionsType: 'ufContract'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        {
            input: {
                id: 'municipioContrato',
                label: 'Município do Contrato'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        },
        ...(contractRef === 'RS'
            ? [
                {
                    select: {
                        id: 'opcaoCompra',
                        label: 'Opção de compra',
                        optionsType: 'booleanType',
                        placeholder: '-'
                    },
                    layout: {
                        type: 'col',
                        layout: { base: 12, md: 4 }
                    }
                } as const
            ]
            : []),
    ]

    if (UFconditional.includes(contractRef)) {
        data.push({
            input: {
                id: 'numeroDudaPago',
                label: 'Numero do DUDA',
                type: 'number',
                maxLength: 32,
                onKeyDown: (e: any) =>
                    ['e', 'E', '+', '-', '.', ',', '='].includes(e.key) &&
                    e.preventDefault()
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 4 }
            }
        } as any)
    }

    return data as FormContractInterface[]
}
